import { type FC, type RefObject, useState } from "react";

import { FRAME_GUTTER } from "@styled/document_frame";
import { INSERT_PLUS_WIDTH, InsertGapMarker } from "@styled/insert_gap_marker";

import { DraftingSectionEditor } from "./drafting_section_editor";
import { useInsertGap } from "./use_insert_gap";

type Editing = { before: number; top: number; left: number };

// The + sits centered in the frame's gutter, so it never covers his text.
const PLUS_OFFSET = (FRAME_GUTTER + INSERT_PLUS_WIDTH) / 2;

// Insert here over the drawn draft: the + at the gap he points to, and the
// section editor it opens. `drawn` changes with the draft's blocks.
export const DraftInsertLayer: FC<{
  frameRef: RefObject<HTMLIFrameElement | null>;
  root: Element | null;
  drawn: unknown;
  enabled: boolean;
}> = ({ frameRef, root, drawn, enabled }) => {
  const [editing, setEditing] = useState<Editing | null>(null);
  const { gap, onHover } = useInsertGap({
    frameRef,
    root,
    drawn,
    enabled: enabled && !editing,
  });
  const markerLeft = gap ? gap.frameLeft - PLUS_OFFSET : 0;

  return (
    <>
      {gap && (
        <InsertGapMarker
          top={gap.frameTop + gap.top}
          left={markerLeft}
          width={gap.frameLeft + gap.left + gap.width - markerLeft}
          onHover={onHover}
          onInsert={() =>
            setEditing({
              before: gap.before,
              top: gap.frameTop + gap.top + 16,
              left: markerLeft,
            })
          }
        />
      )}
      {editing && (
        <DraftingSectionEditor
          target={{ before: editing.before }}
          top={editing.top}
          left={editing.left}
          onClose={() => setEditing(null)}
        />
      )}
    </>
  );
};
